module.exports = __webpack_public_path__ + "static/Windmill-863aa8d479182c5d4b672584a7040f7c.webm";